import { render, staticRenderFns } from "./Sanalsantral.vue?vue&type=template&id=eaddcb96&scoped=true&"
import script from "./Sanalsantral.vue?vue&type=script&lang=js&"
export * from "./Sanalsantral.vue?vue&type=script&lang=js&"
import style0 from "./Sanalsantral.vue?vue&type=style&index=0&id=eaddcb96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaddcb96",
  null
  
)

component.options.__file = "Sanalsantral.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VContainer,
  VContent,
  VIcon,
  VProgressLinear,
})
